import { SessionSystemType } from "doxecure-commons/doxecureModelTypes";

import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { NewSessionView } from "@containers/newSession/NewSessionView";

const NewSessionPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="newSignature">
            <NewSessionView systemType={SessionSystemType.Standard} />
        </AuthenticatedLayout>
    );
}

export default NewSessionPage;